export default "__VITE_ASSET__DqrEf0Vx__"